// extracted by mini-css-extract-plugin
module.exports = {"container":"LoadingSpinner_container__3Eq1V"};